// extracted by mini-css-extract-plugin
export default {"container":"CameraOff__container--AFPDb"};